// extracted by mini-css-extract-plugin
export default {"toggleListWrapper":"ToggleListWrapper_toggleListWrapper__jMiX3"};